import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';

@Injectable({
  providedIn: 'root',
})
export class ValidationService {
  constructor(private messageservice: MessageService) {}

  generatetoast(arr: String[]) {
    arr.forEach((element) => {
      let msg = 'Feltet ' + element + ' er påkrævet.';
      this.messageservice.add({
        severity: 'error',
        summary: 'Error',
        detail: msg,
        life: 4000,
      });
    });
  }

  generateErrorToastWithMessage(message: string) {
    this.messageservice.add({
      severity: 'error',
      summary: 'Error',
      detail: message,
      life: 4000,
    });
  }
}
